<script setup>
import {computed, inject, onMounted, ref, watch} from 'vue'
import {useStore} from "@/store";
const store = useStore()
import {ElNotification} from "element-plus";

watch(
  () => store.messages.slice(), // следим за копией, чтобы отловить push
  (newMessages, oldMessages) => {
    if (newMessages.length > oldMessages.length) {
      const last = newMessages[newMessages.length - 1]
      if (last) {
        ElNotification({
          title: 'Уведомление',
          message: last,
          type: 'error', // можно: success, warning, error, info
          duration: 10000,
          position: 'bottom-right',
        })
      }
    }
  },
  { deep: true }
)
</script>
<template>

</template>